import type { EventBus } from './EventBus';
import type { ScriptedEmail } from '../content/scripted-emails';

export interface ScriptedEmailsOptions {
  bus: EventBus;
  emails: readonly ScriptedEmail[];
}

export class ScriptedEmailsSystem {
  private readonly dispatched = new Set<string>();

  constructor(private readonly opts: ScriptedEmailsOptions) {}

  tick(fictionalMinutes: number): void {
    for (const s of this.opts.emails) {
      if (this.dispatched.has(s.email.id)) continue;
      if (fictionalMinutes < s.fictionalMinutes) continue;
      this.dispatched.add(s.email.id);
      this.opts.bus.emit('email:received', { email: s.email });
    }
  }
}
